module.exports = __webpack_public_path__ + "e533862bb344bb7801139fb6b8aba1bf.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/happy-15.png
// module id = 1526
// module chunks = 0